import styled from 'styled-components';
import { SearchAlt } from "@styled-icons/boxicons-regular/SearchAlt";
import Select from "react-select";
import bannerBg from "../../assets/images/banner-bg.png";

export const Banner = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 16rem;
  background-image: url(${bannerBg});
  background-size: auto;  
  background-color: #f97f88;
 
  h1 {
    font-family: Merengue;
    font-size: 8rem;
    color: #fff;

    @media (min-width: 1100px) {
      font-size: 11rem;
    }
  }

  @media (min-width: 1100px) {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    h1 {
      font-size: 11rem;
     }
  }
`;

export const CategorySelect = styled(Select)`
  flex-grow: 2;
  margin-right: 2rem;

  &.Select--multi {
    .Select-value {
      display: inline-flex;
      align-items: center;
    }
  }

  & .Select-placeholder {
    font-size: smaller;
  }

  & .Select__control--is-focused {
    background-color: none !important;
    border: transparent !important;
    box-sizing: border-box;
    box-shadow: none !important;
  }

  & .Select__input {
    color: #000;
  }

  & .Select__indicator-separator {
    display: none;
  }

  & .Select__control {
    background-color: transparent;
    border-color: transparent;
    box-sizing: border-box;
    cursor: pointer;

    & .Select__clear-indicator {
      visibility: hidden;
    }

    :hover {
      border: transparent !important;

      & .Select__clear-indicator {
        visibility: visible;
      }
    }
  }
`;

export const Group = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;
  list-style-type: none;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const Product = styled.li`
  display: grid;
  grid-template-columns: 1fr 146px;
  border: 1px solid #db899b;
  border-radius: 5px;
  height: 200px;
  padding: 22px;
  background-color: #fff;

  @media (max-width: 767px) {
    border-radius: 0;
    border: 0;
    border-top: 1px solid #db899b;
    grid-template-columns: 1fr 100px;
  }
`;

export const Figure = styled.figure``;

export const Information = styled.div`
  display: grid;
  grid-template-rows: 1fr 20px;
`;

export const Price = styled.div`
  font-weight: 700;
`;

export const Image = styled.img`
  border-radius: 5px;
  width: 146px;

  @media (max-width: 767px) {
    width: 100px;
  }
`;

export const Title = styled.h2``;

export const Header = styled.header`
  font-weight: 700;
  font-size: 3rem;
  padding: 2.3rem 0 3rem 0;
`;

export const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;

  background-color: #fff;
`;

export const Controls = styled.div`
  display: flex;
  flex-basis: auto;
  flex-grow: 1;
  width: 100%;
  max-width: 1100px;
  padding: 2rem 0 1rem 0;
  border-bottom: 1px solid #db899b;
  background-color: #fff;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const Input = styled.input`
  color: #000;
  width: 100%;
  height: 4rem;
  border-radius: 0.8rem;
  background: none;
  border: none;
  outline: 0;
  padding: 0 1.6rem;

  &::placeholder {
    color: #000;
  }
`;

export const Search = styled.div`
  flex-grow: 1;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchIcon = styled(SearchAlt)``;

export const Menu = styled.div`
  padding-bottom: 4rem;

  @media (max-width: 767px) {
    padding: 1rem;
    padding-top: 5rem;
  }
`;

export const ProductSection = styled.section`
  margin-top: 3rem;
`
